import { TypeChecker } from '@attain-apps/type-guards'

/**
 * A document number used to connect BCH workbook rows across source files.
 */
export type DocumentNumber = string
export namespace DocumentNumber {
  export const isDocumentNumber: TypeChecker<DocumentNumber> =
    TypeChecker.isString
}
